module.exports = __webpack_public_path__ + "img/logo-upnvj.8f7bbea5.png";